<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 信息 -->
    <div class=" pdt-20 pdl-20">
      <div
        class="topReturnLink w60 cursor fw-600 color0063ea f16 pdb-10"
        @click="$router.push('/ordermanagement/details')"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>

      <!-- 基本信息 -->
      <div class="basicInfo bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">基本信息</div>
        <el-table :data="basicInfo" style="width: 100%" border>
          <el-table-column prop="userNum" label="客户编号">
            <template slot-scope="scope">
              <span
                v-text="scope.row.userNum ? scope.row.userNum : '- -'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="客户电话">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.payType === 2
                    ? scope.row.useUserPhone
                    : scope.row.phone
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="equipmentNum" label="设备编号">
          </el-table-column>
          <el-table-column prop="customerName" label="设备归属">
          </el-table-column>
          <el-table-column prop="equipmentModel" label="设备型号">
          </el-table-column>
        </el-table>
      </div>

      <!-- 订单信息 -->
      <div class="orderInfo mgt-10 bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">订单信息</div>
        <el-table :data="basicInfo" style="width: 100%" border>
          <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
          <el-table-column prop="payTime" label="交易时间"> </el-table-column>
          <el-table-column prop="isError" label="订单状态">
            <template slot-scope="scope">
              <span v-text="scope.row.isError ? '失败' : '成功'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="useUserPhone" label="购水用户">
          </el-table-column>
          <el-table-column prop="chushuiliang" label="购水量">
          </el-table-column>
          <el-table-column prop="payType" label="支付类型">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.payType === 2
                    ? '微信'
                    : scope.row.payType === 1
                    ? '电子水卡'
                    : '实物水卡'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="是否时效卡支付">
            <template slot-scope="scope">
              <span v-text="scope.row.isTimePackage ? '是' : '否'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="waterType" label="购水类型"> </el-table-column>
          <el-table-column prop="orderPrice" label="实际接水时间（秒）">
            <template slot-scope="scope">
              <span
                v-text="scope.row.realTime ? scope.row.realTime : '暂无数据'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="realWater" label="实际出水量">
            <template slot-scope="scope">
              <span
                v-text="scope.row.realWater ? scope.row.realWater : '- -'"
              ></span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="address" label="接水时长"> </el-table-column>
          <el-table-column prop="address" label="接水量"> </el-table-column> -->
          <el-table-column prop="orderPrice" label="订单金额（元）">
          </el-table-column>

          <el-table-column prop="refundPrice" label="退款金额(元)">
            <template slot-scope="scope">
              <span v-text="scope.row.refundPrice"></span>
              <el-button
                v-if="scope.row.refundMessage"
                type="text"
                size="small"
                @click="refundVisible = true"
                >退款原因</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="payPrice" label="消费金额(赠送/实付)">
            <template slot-scope="scope">
              <span
                v-text="
                  (
                    Number(scope.row.payPrice) +
                    Number(scope.row.walletDiscountPrice)
                  ).toFixed(2) +
                    '（' +
                    scope.row.walletDiscountPrice +
                    '/' +
                    scope.row.payPrice +
                    '）'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="waterAfterPrice" label="消费后水卡余额（元）">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.waterAfterPrice ? scope.row.waterAfterPrice : '- -'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="isError" label="打水异常">
            <template slot-scope="scope">
              <span v-text="scope.row.isError ? '是' : '否'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="upTime" label="订单上传时间">
            <template slot-scope="scope">
              <span v-text="scope.row.upTime ? scope.row.upTime : '- -'"></span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 异常说明弹框 -->
        <el-dialog
          title="异常说明"
          :visible.sync="exceptionVisible"
          width="30%"
          :close-on-click-modal="modalFase"
          center
        >
          <span>{{ exceptionDeclaration }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="exceptionVisible = false"
              >已 知 晓</el-button
            >
          </span>
        </el-dialog>
      </div>

      <!-- 分润信息
      <div class="sharebenefitInfo mgt-10 bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">分润信息</div>
        <el-table :data="sharebenefitInfo" style="width: 100%" border stripe>
          <el-table-column prop="customerName" label="分润人">
          </el-table-column>
          <el-table-column prop="shareProportion" label="分润比例">
          </el-table-column>
          <el-table-column prop="sharePrice" label="分润金额（元）">
          </el-table-column>
        </el-table>
      </div> -->

      <!-- 售后信息 -->
      <!-- <div class="afterInfo mgt-10 bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">售后信息</div>
        <el-table :data="afterInfo" style="width: 100%" border stripe>
          <el-table-column prop="refundNo" label="售后编号">
            <template slot-scope="scope">
              <span
                v-text="scope.row.refundNo ? scope.row.refundNo : '- -'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="applyName" label="申请人"> </el-table-column>
          <el-table-column prop="createTime" label="申请时间">
          </el-table-column>
          <el-table-column prop="afterSalesReason" label="退款原因">
          </el-table-column>
          <el-table-column prop="refundPrice" label="退款金额（元）">
          </el-table-column>
          <el-table-column prop="afterSalesTime" label="审核时间">
          </el-table-column>
          <el-table-column prop="state" label="审核状态">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.state == 2
                    ? '通过'
                    : scope.row.state == 3
                    ? '拒绝'
                    : '申请中'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="afterSalesAnswer" label="审核备注">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.afterSalesAnswer ? scope.row.afterSalesAnswer : '--'
                "
              ></span>
            </template>
          </el-table-column>
        </el-table> -->
      <!-- 售后退款 -->
      <div class="sharebenefitInfo mgt-10 bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">售后退款</div>
        <el-table :data="afterInfo" style="width: 100%" border stripe>
          <el-table-column prop="refundPrice" label="售后金额">
          </el-table-column>
          <el-table-column prop="applyName" label="操作人"> </el-table-column>
          <el-table-column prop="createTime" label="售后时间">
          </el-table-column>
          <el-table-column prop="afterSalesReason" label="售后备注">
          </el-table-column>
          <el-table-column prop="state" label="审核状态">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.state === 1
                    ? '处理中'
                    : scope.row.state === 2
                    ? '成功'
                    : '失败'
                "
              ></span>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state !== 3 && scope.row.state !== 2"
                type="text"
                size="small"
                @click="closeAfter(scope.row)"
                >撤销售后</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 订单补偿 -->
      <div class="sharebenefitInfo mgt-10 bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">订单补偿</div>
        <el-table :data="makeTable" style="width: 100%" border stripe>
          <el-table-column prop="rechargePrice" label="补偿金额">
          </el-table-column>
          <el-table-column prop="applyName" label="操作人"> </el-table-column>
          <el-table-column prop="createTime" label="售后时间">
          </el-table-column>
          <el-table-column prop="afterSalesReason" label="售后备注">
          </el-table-column>
        </el-table>
      </div>

      <!-- 免费送水 -->
      <div class="sharebenefitInfo mgt-10 bg-white pd-10">
        <div class="color1989fa fw-600 mgb-10">免费送水</div>
        <el-table :data="waterTable" style="width: 100%" border stripe>
          <el-table-column prop="equipmentType" label="送水类型">
          </el-table-column>
          <el-table-column prop="equipmentWater" label="水量 ">
          </el-table-column>
          <el-table-column prop="applyName" label="操作人"> </el-table-column>
          <el-table-column prop="createTime" label="售后时间">
          </el-table-column>
        </el-table>
      </div>
      <!-- 
      <div class="flex aic jcc mgt-50">
        <el-button
          class="mgr-30"
          @click="openAfter"
          v-if="
            !ispsss && basicInfo[0].state === 3 && (roleId == 1 || roleId == 24)
            // basicInfo[0].payType !== 7 &&
            // (basicInfo[0].payType == 2
            //   ? !basicInfo[0].isError
            //   : basicInfo[0].isError)
          "
          >售后退款</el-button
        >
        <el-button
          class=" mgr-30"
          @click="openMake"
          v-if="makeTable.length < makeCishu && basicInfo[0].payType !== 2"
          >订单补偿</el-button
        >
        <el-button @click="openWater" v-if="waterTable.length < waterCishu"
          >远程取水</el-button
        >
      </div> -->

      <!-- 售后申请 -->
      <!-- <div class="flex jcc mgt-100 pdb-20">
        <el-button
          @click="aftersaleBtn"
          v-if="
            !ispsss &&
              basicInfo[0].state === 3 &&
              (roleId == 1 || roleId == 24) &&
              basicInfo[0].payType !== 7
          "
          >售后申请</el-button
        >
      </div>-->
    </div>
    <!-- 售后申请弹框 -->
    <el-dialog
      title="售后退款"
      :visible.sync="aftersaleVisible"
      width="30%"
      :close-on-click-modal="modalFase"
      left
    >
      <div class="formBox">
        <el-form
          ref="afterForm"
          :rules="afterFormRules"
          :model="afterForm"
          label-width="80px"
        >
          <el-form-item label="退款原因" prop="desc">
            <el-input
              placeholder="请备注退款原因"
              type="textarea"
              maxlength="100"
              show-word-limit
              v-model="afterForm.desc"
            ></el-input>
          </el-form-item>
        </el-form>
        <div>注：退款通过后，本次订单消费金额将原路返回用户账户。</div>
      </div>
      <span slot="footer" class="dialog-footer flex jcc">
        <el-button @click="aftersaleVisible = false" class="mgr-30"
          >取 消</el-button
        >
        <el-button type="primary" @click="handSubmit('afterForm')"
          >退款</el-button
        >
      </span>
    </el-dialog>

    <!-- 售后补偿弹框 -->
    <el-dialog
      title="售后补偿"
      :visible.sync="makeVisible"
      width="30%"
      :close-on-click-modal="modalFase"
      center
      top="45vh"
    >
      <el-form
        ref="makeForm"
        :rules="makeFormRules"
        :model="makeForm"
        label-width="80px"
      >
        <el-form-item label="充值金额" prop="money">
          <el-input
            v-model="makeForm.money"
            :placeholder="'请输入' + makeMoney + '元以内赠送金额'"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input
            placeholder="请输入备注"
            type="textarea"
            maxlength="100"
            show-word-limit
            v-model="makeForm.desc"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer flex jcc">
        <el-button @click="makeVisible = false" class="mgr-30">取 消</el-button>
        <el-button type="primary" @click="makeSave('makeForm')">充值</el-button>
      </span>
    </el-dialog>

    <!-- 远程取水弹框弹框 -->
    <el-dialog
      title="远程取水"
      :visible.sync="waterVisible"
      width="30%"
      :close-on-click-modal="modalFase"
      center
      top="45vh"
    >
      <el-form
        ref="waterForm"
        :rules="waterFormRules"
        :model="waterForm"
        label-width="80px"
      >
        <el-form-item label="取水类型" prop="type">
          <el-select v-model="waterForm.type" placeholder="请选择取水类型">
            <el-option
              v-for="(v, i) in equipmentArr"
              :key="i"
              :label="v.type"
              :value="v.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水量（L）" prop="water">
          <el-input
            v-model="waterForm.water"
            :placeholder="'请输入' + waterNum + 'L以内水量'"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer flex jcc">
        <el-button @click="waterVisible = false" class="mgr-30"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleWaterSave('waterForm')"
          >免费送水</el-button
        >
      </span>
    </el-dialog>

    <!-- 退款原因弹框 -->
    <el-dialog
      title="退款原因"
      :visible.sync="refundVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-table stripe border :data="refundTableNew" style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="message" label="退款原因" width="180">
        </el-table-column>
        <el-table-column prop="money" label="退款金额(元)" width="180">
        </el-table-column>
        <el-table-column prop="time" label="退款时间"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import store from "../../store";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    const money = (rule, value, callback) => {
      // let reg = this.generateAmountRegex(this.makeMoney);
      let reg = /^(\d+|\d+\.\d+)?$/;
      var numStr = Number(value).toString();
      // 使用正则表达式匹配小数部分
      var match = numStr.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
      if (!value) {
        callback(new Error("请输入金额"));
      } else if (!reg.test(Number(value))) {
        callback(new Error(`仅支持数字，请重新输入`));
      } else if (
        Number(value) < 0 ||
        Number(value) > Number(this.makeMoney) ||
        (match[1] && match[1].length >= 2)
      ) {
        callback(new Error(`仅支持0到${this.makeMoney}之间，最多保留一位小数`));
      } else {
        callback();
      }
    };

    const water = (rule, value, callback) => {
      let reg = /^(\d+|\d+\.\d+)?$/;

      var numStr = Number(value).toString();
      // 使用正则表达式匹配小数部分
      var match = numStr.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
      if (!value) {
        callback(new Error("请输入水量"));
      } else if (!reg.test(Number(value))) {
        callback(new Error(`仅支持数字，请重新输入`));
      } else if (
        Number(value) < 0 ||
        Number(value) > Number(this.waterNum) ||
        (match[1] && match[1].length >= 2)
      ) {
        callback(new Error(`仅支持0到${this.waterNum}之间，最多保留一位小数`));
      } else {
        callback();
      }
    };
    return {
      modalFase: false,
      basicInfo: [], //基本信息数据
      orderInfo: [], //订单信息数据
      sharebenefitInfo: [], //分润信息数据
      afterInfo: [], //售后信息数据
      exceptionVisible: false, //异常说明弹框是否打开
      exceptionDeclaration: "", //异常说明弹框内异常说明
      aftersaleVisible: false, //售后申请弹框是否打开
      afterForm: { money: "", desc: "" }, //售后申请弹框数据
      orderNo: "",
      afterFormRules: {
        desc: [{ required: true, message: "请填写退款原因", trigger: "blur" }],
      },
      ispsss: "",
      roleId: null,
      refundTable: [], //售后退款表格
      makeTable: [], //订单补偿表格
      waterTable: [], //免费送水表格
      makeForm: {
        money: "",
        desc: "",
      }, //补偿弹框表单
      makeFormRules: {
        desc: [{ required: true, message: "请填写备注", trigger: "blur" }],
        money: [{ required: true, validator: money, trigger: "blur" }],
      },
      makeVisible: false,
      waterForm: {
        type: "",
        water: "",
        money: "",
      }, //远程取水弹框表格
      waterFormRules: {
        type: [{ required: true, message: "请选择取水类型", trigger: "blur" }],
        money: [{ required: true, message: "请输入金额", trigger: "blur" }],
        water: [{ required: true, validator: water, trigger: "blur" }],
      },
      waterVisible: false,
      makeMoney: null,
      makeCishu: null,
      waterCishu: null,
      waterNum: null,
      dictName: null,
      equipmentInfo: null,
      equipmentArr: [],
      commod: null,
      price: null,
      refundVisible: false,
      refundTableNew: [],
    };
  },
  created() {
    this.orderNo = this.$route.query.orderNo;
    // this.orderNo = "EO2406241505080976801";
    this.getorderDetail();
    this.getROLE();
    // this.getMake(); //暂时隐藏
    // this.getWater(); //暂时隐藏
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 获取补偿金额
    getMake() {
      this.$api.operator.makeInfo().then((res) => {
        if (res.code === 200) {
          this.makeMoney = res.data.salesCompensatePrice;
          this.makeCishu = Number(res.data.salesCompensateNum);
        }
      });
    },

    // 获取最大水量
    getWater() {
      this.$api.operator.waterInfo().then((res) => {
        if (res.code === 200) {
          this.waterNum = res.data.salesSendWater;
          this.waterCishu = Number(res.data.salesSendNum);
        }
      });
    },

    // 查询设备详情
    getEquipment(n) {
      this.$api.order.equipmentQuery({ clientId: n }).then((res) => {
        if (res.code === 200) {
          console.log(res, "设备详情");
          if (res.data.dictName) {
            this.dictName = res.data.dictName;
          }
          this.equipmentInfo = res.data;
          this.equipmentArr = Object.values(res.data.waterPriceList).map(
            (arr) => arr[0]
          );
          console.log(this.equipmentArr);
        }
      });
    },

    // 免费送水按钮
    handleWaterSave(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          let matchedObject = this.equipmentArr.find(
            (obj) => obj.type === this.waterForm.type
          );
          if (matchedObject) {
            this.price = matchedObject.equipmentPrice;
            let obj = JSON.parse(matchedObject.equipmentSkuInfo);
            if (this.dictName !== "冷热温一体机") {
              this.commod = obj.waterNum ? obj.waterNum : 1;
            } else {
              this.commod = obj.commod;
            }
          }

          handleConfirm("确认送水吗?", "info")
            .then(() => {
              this.$api.shebeiSet
                .beforeHttp({ equipmentNum: this.basicInfo[0].equipmentNum })
                .then((res) => {
                  if (res.code === 200) {
                    setTimeout(() => {
                      this.$api.order
                        .equipmentQuery({
                          clientId: this.basicInfo[0].equipmentNum,
                        })
                        .then((res) => {
                          if (res.code === 200) {
                            if (res.data.status === 0) {
                              handleAlert("设备离线中", "error");
                              return;
                            }
                            if (
                              res.data.njgEquipmentWaterNumBeans[0].status ==
                                1 ||
                              res.data.njgEquipmentWaterNumBeans[0].status ==
                                5 ||
                              res.data.njgEquipmentWaterNumBeans[1].status ===
                                1 ||
                              res.data.njgEquipmentWaterNumBeans[1].status === 5
                            ) {
                              handleAlert("设备正在使用中", "error");
                              return;
                            }
                            this.$api.order
                              .addWater({
                                commod: Number(this.commod),
                                orderNo: this.orderNo,
                                price: (
                                  Number(this.waterForm.water) *
                                  Number(this.price)
                                ).toFixed(2),
                                type: this.waterForm.type,
                                water: Number(this.waterForm.water),
                              })
                              .then((res) => {
                                if (res.code === 200) {
                                  handleAlert("下发成功", "success");
                                  // this.getWaterList();
                                  this.getorderDetail();
                                  this.waterVisible = false;
                                }
                              });
                          }
                        });
                    }, 1000);
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 打开免费送水弹框
    openWater() {
      // this.getWater();
      this.waterForm = { type: "", water: "", money: "" };
      this.waterVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.waterForm.clearValidate();
      });
    },

    // 打开补偿弹框
    openMake() {
      // this.getMake();
      this.makeForm = {
        money: "",
        desc: "",
      };
      this.makeVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.makeForm.clearValidate();
      });
    },
    // 订单补偿列表
    getMakeList() {
      this.$api.order
        .makeList({ pageNum: 1, pageSize: 100, orderNo: this.orderNo })
        .then((res) => {
          if (res.code === 200) {
            this.makeTable = res.data.rows;
          }
        });
    },
    // 送水列表
    getWaterList() {
      this.$api.order
        .waterList({ pageNum: 1, pageSize: 100, orderNo: this.orderNo })
        .then((res) => {
          if (res.code === 200) {
            console.log(res, "送水列表");
            this.waterTable = res.data.rows;
          }
        });
    },
    // 新增补偿
    makeSave(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认充值吗?", "info")
            .then(() => {
              this.$api.order
                .addMake({
                  orderNo: this.orderNo,
                  money: Number(this.makeForm.money),
                  message: this.makeForm.desc,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("充值成功", "success");
                    this.makeVisible = false;
                    // this.getMakeList();
                    this.getorderDetail();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    // 打开售后弹框
    openAfter() {
      this.afterForm = { desc: "" };
      this.aftersaleVisible = true;
    },
    // 取消售后
    closeAfter(row) {
      handleConfirm("售后撤销后不会进行订单退款,确认撤销吗?", "info")
        .then(() => {
          this.$api.order.closeAfter({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("订单退款已撤销", "success");
              this.getorderDetail();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },
    // 获取订单详情
    getorderDetail() {
      this.basicInfo = [];
      this.afterInfo = [];
      this.sharebenefitInfo = [];
      this.$api.order.orderDetails({ orderNo: this.orderNo }).then((res) => {
        this.basicInfo.push(res.data.order);
        this.basicInfo.forEach((v, i) => {
          let obj = JSON.parse(v.equipmentSku);
          v.chushuiliang = obj.出水量;
          v.waterType = obj.type;
        });
        let refundYuanyin = JSON.parse(res.data.order.refundMessage);
        this.refundTableNew = refundYuanyin;
        // this.getEquipment(res.data.order.equipmentNum);
        this.afterInfo = res.data.sales;

        this.afterInfo.forEach((v) => {
          if (v.state !== 3) {
            this.ispsss = 1;
          } else {
            return;
          }
        });
        if (res.data.salesSend) {
          this.waterTable = res.data.salesSend;
        }
        if (res.data.salesCompensate) {
          this.makeTable = res.data.salesCompensate;
        }

        this.sharebenefitInfo = res.data.shares;
      });
    },
    // 订单信息异常说明按钮点击事件
    openexceptionVisible(row) {
      this.exceptionVisible = true;
    },
    // 点击售后申请按钮，打开售后弹框
    aftersaleBtn() {
      this.aftersaleVisible = true;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.afterForm.clearValidate();
      });
    },
    // 售后申请弹框内提交按钮
    handSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认发起本笔订单全额退款吗？", "操作提示", {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(() => {
              this.$api.order
                .openAfter({
                  orderNo: this.orderNo,
                  reason: this.afterForm.desc,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: "申请成功",
                      type: "success",
                    });
                    this.aftersaleVisible = false;
                    this.getorderDetail();
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消提交",
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

/deep/ .el-dialog {
  .el-form {
    margin: 0 auto !important;
  }
  .el-form-item__content {
    display: flex !important;
  }
  .el-form-item__label {
    width: 100px !important;
  }
  .el-textarea,
  .el-input {
    width: 250px !important;
  }
}
</style>
